import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MarketPlaceTabs from "./MarketplaceSetup/MarketPlaceTabs";
import {
  addIntegrations,
  updateIntegrations,
} from "../../../redux/slices/setting/settingApi";
import { useSelector } from "react-redux";
import { showToast } from "../../../components";
import {
  addIntegrationsBs,
  updateIntegrationsBs,
} from "../../../redux/slices/ats/benchSales/benchSalesApi";
import { addIntegrationsNm, updateIntegrationsNm } from "../../../redux/slices/nonitMarketing/nonitMarketingApi";

const MarketplaceSetup = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [integrations, setIntegrations] = useState({});
  const { user } = useSelector((state) => state.auth);

  const { category, type } = location.state || {};

  useEffect(() => {
    if (!category || !type) {
      navigate("/marketplace");
      return;
    }
  }, [category, type, navigate]);

  const handleUpdateIntegration = async (data, callback) => {
    try {
      const {
        category,
        type,
        name,
        checkboxValue,
        isEditMode,
        uiid,
        payload,
        updatedConfig,
        selectedModule,
        email,
        isOAuth,
        authId
      } = data;

      if (isEditMode) {
        const updateResponse =
          selectedModule === "bs"
            ? await updateIntegrationsBs({ uiid, payload }): selectedModule === "nm"
            ? await updateIntegrationsNm({ uiid, payload })
            : selectedModule === "ats"
              ? await updateIntegrations({ uiid, payload })
              : {};
        if (updateResponse.success) {
          showToast("Integration Updated successfully", "success");
          callback?.();
          // navigate("/marketplace");
        } else {
          showToast("Error while updating integration!", "error");
        }
      } else {
        const addPayload = {
          coll: (selectedModule === "bs" || selectedModule === "nm") ? "Integrationbs" : "Integration",
          payload: {
            name: name || "",
            category,
            type,
            addedBy: user?.data?.uiid,
            config: updatedConfig,
            ...(email && { email }), //  include email for Gmail/Outlook OAuth
            ...(isOAuth && { isOAuth }),
            ...(authId && {authId})
          },
        };

        const res =
        selectedModule === "bs" 
            ? await addIntegrationsBs(addPayload)
            :selectedModule === "nm" 
            ? await addIntegrationsNm(addPayload): 
            selectedModule === "ats"
              ? await addIntegrations(addPayload)
              : {};

        if (res?.data?.data) {
          const key = `${category}-${type}`;
          const updatedIntegrations = {
            ...integrations,
            [key]: res.data.data,
          };
          setIntegrations(updatedIntegrations);
          showToast("Integration added successfully", "success");
          callback?.();
          // navigate("/marketplace");
        } else if (res?.error?.code === 11000) {
          showToast(
            "An integration with this display name already exists!",
            "error",
          );
        } else {
          showToast("Error while adding!", "error");
        }
      }
    } catch (err) {
      console.error("Error adding integration:", err);
    }
  };

  const handleClose = () => {
    navigate("/marketplace");
  };

  if (!category || !type) {
    return null;
  }

  return (
    <div className="p-2">
      <MarketPlaceTabs
        onClose={handleClose}
        category={Number(category)}
        type={Number(type)}
        integrations={integrations}
        onUpdate={handleUpdateIntegration}
      />
    </div>
  );
};

export default MarketplaceSetup;
